import * as THREE from 'three';

export default function useLights(scene, camera) {
  const ambientLight = new THREE.AmbientLight(0xffffff, 0.45 * Math.PI);
  scene.add(ambientLight);

  const cameraLight = new THREE.PointLight(0xffffff, 1, 0, 0);
  cameraLight.target = new THREE.Vector3(0, 0, 0);
  cameraLight.position.set(1.2, -1, 0);
  camera.add(cameraLight);
}
